import { useMemo } from "react"

import cls from "classnames"
import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"

import { getCreateBaMaxStep } from "../../../../Utils/onboarding/getJourneyState"
import { STEPS } from "../../utils/constants/steps"

const OnboardingDots = () => {
  const { pathname } = useLocation()
  const userState = useSelector((state) => state.user)

  const isNewBusiness = pathname?.includes("/create-account")
  const maxCreateSteps = isNewBusiness ? getCreateBaMaxStep(userState) : 6
  const steps = STEPS.slice(0, maxCreateSteps)

  const activeIndex = useMemo(() => {
    const found = steps.find((s) => pathname.includes(`${s.key}`))
    const key = found?.key ?? steps[0].key
    return Math.max(
      0,
      steps.findIndex((s) => s.key === key)
    )
  }, [pathname, steps])

  return (
    <div className="ob-dots" aria-label="Progress">
      {steps.map((_, i) => (
        <span key={i} className={cls("ob-dot", { "is-active": i <= activeIndex })} />
      ))}
    </div>
  )
}

export default OnboardingDots
